/*
* @描述: 工单后台管理
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-02-19 11:11:51
*/
<template>
    <div class="page_container">
        <div class="admin_manage_wrapper">
            <div class="admin_manage_header">
                <div :class="{'active': tabActiveName==='process'}"
                     class="admin_manage_header_title"
                     @click="handleClickHeaderTitleItem('process')">工单流程
                </div>
                <div :class="{'active': tabActiveName==='roles'}"
                     class="admin_manage_header_title"
                     @click="handleClickHeaderTitleItem('roles')">工单角色
                </div>
                <!-- <div :class="{'active': tabActiveName==='other'}"
                     class="admin_manage_header_title"
                     @click="handleClickHeaderTitleItem('other')">其他设置
                </div> -->
            </div>
            <div v-loading="loading" class="admin_manage_content">
                <div v-if="tabActiveName==='process'" class="process_site_wrap">
                    <div class="process_site_form_wrap">
                        <el-form label-position="top"
                                 :model="processSetForm"
                                 size="small">
                            <div id="initiate_title" class="page_little_title">
                                <span class="title">工单发起</span>
                            </div>
                            <el-form-item label="创建工单" prop="form_field">
                                <el-button size="mini" type="primary" @click="handleClickSetFormField">自定义工单内容
                                </el-button>
                                <el-button type="text" @click="handleClickReview">预览页面</el-button>
                                <div class="hint_text">可设置创建工单时需填写的内容字段</div>
                            </el-form-item>
                            <el-form-item label="是否需要审批" prop="is_create_approve">
                                <div class="flex_wrap">
                                    <el-switch v-model="processSetForm.is_create_approve"
                                               :active-value="1"
                                               :inactive-value="0"
                                               active-color="#2990FF"
                                               inactive-color="#999999">
                                    </el-switch>
                                    <div v-if="processSetForm.is_create_approve===1" @click="handleClickApproveProcess('工单申请', 'workorder_create')">
                                        <span>前往</span>
                                        <span class="link-label">审批流程</span>
                                        <span>设置</span>
                                    </div>
                                </div>
                                <div class="hint_text">开启后，建立工单需审批通过后才可创建成功</div>
                            </el-form-item>
                            <div id="assign_title" class="page_little_title">
                                <span class="title">工单分配</span>
                            </div>
                            <el-form-item prop="is_auto_assign">
                                <div slot="label">
                                    <span>自动分配</span>
                                    <span class="hint_text">（关闭时默认手动分配）</span>
                                </div>
                                <el-switch v-model="processSetForm.is_auto_assign"
                                           :active-value="1"
                                           :inactive-value="0"
                                           active-color="#2990FF"
                                           inactive-color="#999999"
                                           @change="handleIsAutoAssignChange">
                                </el-switch>
                                <div class="hint_text">
                                    开启后，根据规则逻辑自动分配（自动分配时间范围内空闲人员），当无合适人员时需手动分配
                                </div>
                                <div v-if="processSetForm.is_auto_assign===1">
                                    <ul class="auto_assign_rule_list">
                                        <draggable v-model="processSetForm.auto_assign_rule"
                                                   :animation="300"
                                                   :forceFallback="true">
                                            <li v-for="(item,index) in processSetForm.auto_assign_rule"
                                                class="auto_assign_rule_item">
                                                <div class="conditions_wrap">
                                                    <div class="flex_js_wrap">
                                                        <div class="title" v-text="`优先级${index+1}`"></div>
                                                        <div>
                                                            <span>符合以下：</span>
                                                            <el-select v-model="item.boolean"
                                                                       class="boolean_select"
                                                                       size="mini">
                                                                <el-option label="所有" value="and"></el-option>
                                                                <el-option label="任一" value="or"></el-option>
                                                            </el-select>
                                                            <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                                  @click="processSetForm.auto_assign_rule.splice(index,1)">
                                                        <i class="iconfont icon-shanchu1"></i>
                                                    </span>
                                                        </div>
                                                    </div>
                                                    <ul class="assign_rules_list">
                                                        <li v-for="(rule,rule_index) in item.rules"
                                                            class="assign_rules_item">
                                                            <div class="field_select_wrap">
                                                                <el-select v-model="rule.field_key"
                                                                           placeholder="请选择筛选的字段"
                                                                           @change="handleSelectFieldKeyChange(rule)">
                                                                    <el-option v-for="field in ruleFieldList"
                                                                               :label="field.field_name"
                                                                               :value="field.field_key"></el-option>
                                                                </el-select>
                                                            </div>
                                                            <div class="operator_select_wrap">
                                                                <el-select v-model="rule.operator" disabled>
                                                                    <el-option label="满足" value="="></el-option>
                                                                </el-select>
                                                            </div>
                                                            <div class="field_value_form_wrap">
                                                                <div v-if="ruleFieldList[rule.field_key]"
                                                                     style="height: 32px">
                                                                    <el-select
                                                                            v-if="ruleFieldList[rule.field_key].condition_type === 'options'"
                                                                            v-model="rule.field_value"
                                                                            :placeholder="'请选择' + rule.field_name"
                                                                            collapse-tags
                                                                            filterable
                                                                            multiple
                                                                            size="small"
                                                                            @change="handleOptionsFieldChange(rule,$event)">
                                                                        <el-option
                                                                                v-for="option in ruleFieldList[rule.field_key].extend.options"
                                                                                :label="option.label"
                                                                                :value="option.value">
                                                                        </el-option>
                                                                    </el-select>
                                                                    <el-select
                                                                            v-if="ruleFieldList[rule.field_key].condition_type === 'radio_workorder_type'"
                                                                            v-model="rule.field_value"
                                                                            :placeholder="'请选择' + rule.field_name"
                                                                            collapse-tags
                                                                            filterable
                                                                            multiple
                                                                            size="small"
                                                                            @change="handleWorkOrderFieldChange(rule,$event)">
                                                                        <el-option
                                                                                v-for="option in ruleFieldList[rule.field_key].extend.options"
                                                                                :label="option.label || option.name"
                                                                                :value="option.value || option.id">
                                                                        </el-option>
                                                                    </el-select>
                                                                    <el-select
                                                                            v-else-if="ruleFieldList[rule.field_key].condition_type === 'contact'"
                                                                            v-model="rule.field_value"
                                                                            :placeholder="'请选择' + ruleFieldList[rule.field_key].field_name"
                                                                            :remote-method="getContactList"
                                                                            collapse-tags
                                                                            filterable
                                                                            multiple
                                                                            remote
                                                                            size="small"
                                                                            @remove-tag="handleRemoveContactTag($event,rule)">
                                                                        <el-option v-for="user in contactOptions"
                                                                                   :key="user.uid"
                                                                                   :label="user.name"
                                                                                   :value="user.uid"
                                                                                   @click.native="handleContactFieldChange(rule,user)">
                                                                        </el-option>
                                                                    </el-select>
                                                                    <el-select
                                                                            v-else-if="ruleFieldList[rule.field_key].condition_type === 'department'"
                                                                            ref="depSelect"
                                                                            v-model="rule.field_text"
                                                                            :placeholder="'请选择' + ruleFieldList[rule.field_key].field_name"
                                                                            clearable
                                                                            collapse-tags
                                                                            multiple
                                                                            size="small"
                                                                            @clear="handleClickClearDepartment(rule, rule_index)"
                                                                            @remove-tag="handleRemoveDepartmentTag(rule, rule_index)">
                                                                        <el-option :value="[]"
                                                                                   style="height: auto; padding: 0">
                                                                            <el-tree
                                                                                    :ref="`dep_select_tree${rule_index}`"
                                                                                    :data="departmentList"
                                                                                    :expand-on-click-node="false"
                                                                                    :props="{ children: 'children', label: 'relate_name' }"
                                                                                    :show-checkbox="rule.system_type === 'system'"
                                                                                    check-on-click-node
                                                                                    check-strictly
                                                                                    default-expand-all
                                                                                    highlight-current
                                                                                    node-key="relate_id"
                                                                                    size="mini"
                                                                                    @check-change="(data, checked, indeterminate)=>handleDepartmentCheckChange(data, checked, indeterminate, rule)">
                                                                            </el-tree>
                                                                        </el-option>
                                                                    </el-select>
                                                                    <el-date-picker
                                                                            v-else-if="ruleFieldList[rule.field_key].condition_type === 'date'"
                                                                            v-model="rule.field_value"
                                                                            :editable="false"
                                                                            end-placeholder="结束日期"
                                                                            format="yyyy/MM/dd"
                                                                            range-separator="～"
                                                                            size="small"
                                                                            start-placeholder="开始日期"
                                                                            type="daterange"
                                                                            value-format="yyyy-MM-dd"
                                                                            @change="handleDateFieldChange($event, rule)">
                                                                    </el-date-picker>
                                                                    <el-select
                                                                            v-if="ruleFieldList[rule.field_key].condition_type === 'workorder_role'"
                                                                            v-model="rule.field_value"
                                                                            :placeholder="'请选择' + rule.field_name"
                                                                            collapse-tags
                                                                            filterable
                                                                            multiple
                                                                            size="small"
                                                                            @focus="handleWorkOrderRoleSelectFocus(ruleFieldList[rule.field_key])"
                                                                            @change="handleWorkOrderFieldChange(rule,$event)">
                                                                        <el-option
                                                                                v-for="option in ruleFieldList[rule.field_key].options"
                                                                                :label="option.name"
                                                                                :value="option.id">
                                                                        </el-option>
                                                                    </el-select>
                                                                </div>

                                                                <el-input v-else placeholder="请选择筛选的字段"
                                                                          size="small"></el-input>
                                                            </div>
                                                            <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                                  @click.stop="item.rules.splice(rule_index,1)">
                                                        <i class="el-icon-remove"></i>
                                                    </span>
                                                        </li>
                                                    </ul>
                                                    <span class="link-label"
                                                          @click="handleClickAddPrerequisites(item.rules)">
                                                <i class="el-icon-plus"></i>
                                                <span>添加条件</span>
                                            </span>
                                                </div>
                                                <div class="personnel_wrap">
                                                    <el-form-item label="自动分配处理人员（可多选）" prop="assign_uids">
                                                        <el-select v-model="item.assign_uids"
                                                                   collapse-tags
                                                                   filterable
                                                                   multiple
                                                                   placeholder="请选择自动分配处理人员"
                                                                   remote>
                                                            <el-option v-for="user in assignContactOptions"
                                                                       :key="user.id"
                                                                       :label="user.name"
                                                                       :value="user.id"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </div>
                                            </li>
                                        </draggable>
                                    </ul>
                                    <div class="add_rule_btn" @click="handleClickAddAssignRule">
                                        <i class="el-icon-plus"></i>
                                        <span>添加规则</span>
                                    </div>
                                </div>
                            </el-form-item>
                            <div id="implementation_title" class="page_little_title">
                                <span class="title">工单实施</span>
                            </div>
                            <ul class="mode_list">
                                <li :class="{'active':processSetForm.mode===1}"
                                    class="mode_item"
                                    @click="handleClickWorkOrderMode(1)">极简模式（只可单实施人）<br>实施开始-实施结束
                                </li>
                                <li :class="{'active':processSetForm.mode===2}"
                                    class="mode_item"
                                    @click="handleClickWorkOrderMode(2)">简约工程模式<br>出发-实施开始-实施结束-结单
                                </li>
                            </ul>
                            <el-form-item :class="{'disable_form_item': processSetForm.mode===1}"
                                          label="实施人员出发审批" prop="is_travel_approve">
                                <div class="flex_wrap">
                                    <el-switch v-model="processSetForm.is_travel_approve"
                                               :active-value="1"
                                               :disabled="processSetForm.mode===1"
                                               :inactive-value="0"
                                               active-color="#2990FF"
                                               inactive-color="#999999">
                                    </el-switch>
                                    <div v-if="processSetForm.is_travel_approve===1" @click="handleClickApproveProcess('工单出发', 'workorder_travel')">
                                        <span>前往</span>
                                        <span class="link-label">审批流程</span>
                                        <span>设置</span>
                                    </div>
                                </div>
                                <div class="hint_text">
                                    开启后，实施人员出发需触发审批流程审批通过后才可同意前往，关闭后直接确认到达现场即可
                                </div>
                            </el-form-item>
                            <el-form-item label="是否需现场打卡证明" prop="is_clock">
                                <el-switch v-model="processSetForm.is_clock"
                                           :active-value="1"
                                           :inactive-value="0"
                                           active-color="#2990FF"
                                           inactive-color="#999999">
                                </el-switch>
                                <div class="hint_text">开启后，每日工作会保留现场打卡记录</div>
                            </el-form-item>
                            <el-form-item label="客户资料与实施人员共享" prop="is_share">
                                <el-switch v-model="processSetForm.is_share"
                                           :active-value="1"
                                           :inactive-value="0"
                                           active-color="#2990FF"
                                           inactive-color="#999999">
                                </el-switch>
                                <div class="hint_text">
                                    员工创建工单关联的已有客户的商机、订单数据（不包含产品金额）实施人员可查看
                                </div>
                            </el-form-item>
                            <el-form-item label="每日工作描述" prop="is_feedback">
                                <el-switch v-model="processSetForm.is_feedback"
                                           :active-value="1"
                                           :inactive-value="0"
                                           active-color="#2990FF"
                                           inactive-color="#999999">
                                </el-switch>
                                <div class="hint_text">开启时，每日工作描述为必填；关闭时，每日工作描述非必填</div>
                            </el-form-item>
                            <el-form-item label="催单强提醒" prop="is_force_remind">
                                <el-switch v-model="processSetForm.is_force_remind"
                                           :active-value="1"
                                           :inactive-value="0"
                                           active-color="#2990FF"
                                           inactive-color="#999999">
                                </el-switch>
                                <div class="hint_text">开启时，每次打开澜精灵会出现弹窗提醒</div>
                            </el-form-item>
                            <el-form-item label="工单转单" prop="is_transfer">
                                <el-switch v-model="processSetForm.is_transfer"
                                           :active-value="1"
                                           :inactive-value="0"
                                           active-color="#2990FF"
                                           inactive-color="#999999">
                                </el-switch>
                                <div class="hint_text">开启时，工单实施人员可将该工单转给其他人员，不影响管理人员分配
                                </div>
                            </el-form-item>
                            <div id="settlement_title" class="page_little_title">
                                <span class="title">工单结单</span>
                            </div>
                            <el-form-item prop="is_finish_upload">
                                <el-checkbox v-model="processSetForm.is_finish_upload" :false-label="0"
                                             :true-label="1">上传实施报告/证明
                                </el-checkbox>
                            </el-form-item>
                            <el-form-item prop="is_finish_content">
                                <el-checkbox v-model="processSetForm.is_finish_content" :false-label="0"
                                             :true-label="1">填写结单描述
                                </el-checkbox>
                            </el-form-item>
                            <el-form-item label="内部工单评价" prop="is_evaluate">
                                <el-switch v-model="processSetForm.is_evaluate"
                                           :active-value="1"
                                           :inactive-value="0"
                                           active-color="#2990FF"
                                           inactive-color="#999999">
                                </el-switch>
                                <div class="hint_text">开启时，需对实施者进行评分评价</div>
                            </el-form-item>
                        </el-form>
                    </div>
                    <ul class="process_anchor_list">
                        <li :class="{'active':process_anchor==='initiate'}" class="process_anchor_item"
                            @click="handleClickProcessAnchorItem('initiate')">工单发起
                        </li>
                        <li :class="{'active':process_anchor==='assign'}" class="process_anchor_item"
                            @click="handleClickProcessAnchorItem('assign')">工单分配
                        </li>
                        <li :class="{'active':process_anchor==='implementation'}" class="process_anchor_item"
                            @click="handleClickProcessAnchorItem('implementation')">工单实施
                        </li>
                        <li :class="{'active':process_anchor==='settlement'}" class="process_anchor_item"
                            @click="handleClickProcessAnchorItem('settlement')">工单结单
                        </li>
                    </ul>
                    <ReviewFormDialog v-if="reviewFormDialog"
                                      :dialogVisible.sync="reviewFormDialog"
                                      :formInfoList="formInfoList"
                                      :review_form_type_list="reviewFormTypeList"/>
                    <div class="process_site_footer">
                        <el-button size="small" @click="handleClickCancel">取消</el-button>
                        <el-button size="small" type="primary" @click="handleClickProcessConfirm">提交</el-button>
                    </div>
                </div>
                <div v-else-if="tabActiveName==='roles'" class="roles_site_wrap">
                    <div class="roles_site_form_wrap">
                        <el-form 
                            ref="rolesSetForm"
                            :model="rolesSetForm"
                            :rules="rolesSetFormRules"
                            label-position="top"
                            size="small">
                            <div class="page_little_title">
                                <span class="title">工单发起</span>
                            </div>
                            <el-form-item :label="rolesSetForm.create_user.role_name" prop="create_user">
                                <el-select v-model="rolesSetForm.create_user.role_range_text"
                                           multiple
                                           collapse-tags
                                           placeholder="请选择范围"
                                           popper-class="selectPopperHideClass"
                                           @focus="handleCreatorSelectFocus">
                                </el-select>
                            </el-form-item>
                            <div class="page_little_title">
                                <span class="title">工单分配</span>
                            </div>
                            <el-form-item prop="assign_user">
                                <div slot="label">
                                    <div class="flex_wrap">
                                        <el-input v-if="rolesSetForm.assign_user.is_edit"
                                                  v-model="rolesSetForm.assign_user.role_name"
                                                  class="role_name_input"
                                                  placeholder="请输入角色名称"
                                                  size="mini"
                                                  @blur="handleRoleNameInputBlur(rolesSetForm.assign_user)"
                                                  @keyup.enter.native="handleRoleNameInputBlur(rolesSetForm.assign_user)"></el-input>
                                        <span v-else v-text="rolesSetForm.assign_user.role_name"></span>
                                        <span v-if="!rolesSetForm.assign_user.is_edit"
                                              class="handle_icon_wrap"
                                              @click="handleClickRoleNameEdit(rolesSetForm.assign_user)">
                                            <i class="iconfont icon-bianji"></i>
                                        </span>
                                    </div>
                                </div>
                                <el-select v-model="rolesSetForm.assign_user.role_range_text"
                                           multiple
                                           collapse-tags
                                           placeholder="请选择范围"
                                           popper-class="selectPopperHideClass"
                                           @focus="handleAssigneeSelectFocus"></el-select>
                                <div class="hint_text">若不选择范围，则公司没有分配人，工单无法分配实施人</div>
                            </el-form-item>
                            <div class="page_little_title">
                                <span class="title">工单实施</span>
                            </div>
                            <el-form-item prop="processing_user">
                                <ul>
                                    <li v-for="(item,index) in rolesSetForm.processing_user" class="role_range_item">
                                        <el-form-item prop="assignee">
                                            <div slot="label" class="flex_js_wrap">
                                                <div class="flex_wrap">
                                                    <el-input 
                                                        v-if="item.is_edit"
                                                        v-model="item.role_name"
                                                        class="role_name_input"
                                                        placeholder="请输入角色名称"
                                                        size="mini"
                                                        @blur="handleRoleNameInputBlur(item)"
                                                        @keyup.enter.native="handleRoleNameInputBlur(item)"
                                                        >
                                                    </el-input>
                                                    <span v-else v-text="item.role_name"></span>
                                                    <span v-if="!item.is_edit"
                                                          class="handle_icon_wrap"
                                                          @click="handleClickRoleNameEdit(item)">
                                                        <i class="iconfont icon-bianji"></i>
                                                    </span>
                                                </div>
                                                <span v-if="rolesSetForm.processing_user.length>1"
                                                      class="handle_icon_wrap handle_icon_danger_wrap" @click="handleProcessingUserDel(item,index)">
                                                    <i class="iconfont icon-shanchu1"></i>
                                                </span>
                                            </div>
                                            <el-select v-model="item.role_range_text"
                                                       multiple
                                                       collapse-tags
                                                       placeholder="请选择范围"
                                                       popper-class="selectPopperHideClass"
                                                       @focus="handleImplementerRolesSelectFocus(item.role_range,index)"></el-select>
                                            <div class="hint_text">若不选择范围，则公司没有实施人，分配时无法选择人员
                                            </div>
                                        </el-form-item>
                                    </li>
                                </ul>
                                <div class="add_rule_btn" @click="handleClickAddProcessingRoles">
                                    <i class="el-icon-plus"></i>
                                    <span>添加自定义实施角色</span>
                                </div>
                            </el-form-item>
                            <div class="page_little_title">
                                <span class="title">其他</span>
                            </div>
                            <el-form-item>
                                <ul>
                                    <li v-for="(item,index) in rolesSetForm.custom" class="role_range_item">
                                        <el-form-item prop="assignee">
                                            <div slot="label" class="flex_js_wrap">
                                                <div class="flex_wrap">
                                                    <el-input v-if="item.is_edit"
                                                              v-model="item.role_name"
                                                              class="role_name_input"
                                                              placeholder="请输入角色名称"
                                                              size="mini"
                                                              @blur="handleRoleNameInputBlur(item)"
                                                              @keyup.enter.native="handleRoleNameInputBlur(item)"
                                                              ></el-input>
                                                    <span v-else v-text="item.role_name"></span>
                                                    <span v-if="!item.is_edit"
                                                          class="handle_icon_wrap"
                                                          @click="handleClickRoleNameEdit(item)">
                                                        <i class="iconfont icon-bianji"></i>
                                                    </span>
                                                </div>
                                                <span class="handle_icon_wrap handle_icon_danger_wrap" @click="handleCustomDel(item, index)">
                                                    <i class="iconfont icon-shanchu1"></i>
                                                </span>
                                            </div>
                                            <el-select v-model="item.role_range_text"
                                                       multiple
                                                       collapse-tags
                                                       placeholder="请选择范围"
                                                       popper-class="selectPopperHideClass"
                                                       @focus="handleCustomRolesSelectFocus(item.role_range,index)"></el-select>
                                        </el-form-item>
                                    </li>
                                </ul>
                                <div class="add_rule_btn" @click="handleClickAddCustomRoles">
                                    <i class="el-icon-plus"></i>
                                    <span>添加自定义角色</span>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="roles_site_footer">
                        <el-button size="small" @click="handleClickCancel">取消</el-button>
                        <el-button size="small" type="primary" @click="handleClickRolesConfirm">提交</el-button>
                    </div>
                </div>
                <div v-else-if="tabActiveName==='other'" class="other_site_wrap">
                    <div class="other_site_form_wrap">
                        <el-form :model="otherSetForm"
                                 label-position="top"
                                 size="small">
                            <el-form-item label="实施时长类型" prop="duration_type">
                                <el-select v-model="otherSetForm.duration_type">
                                    <el-option label="天" value="day"></el-option>
                                    <el-option label="半天" value="half_day"></el-option>
                                    <el-option label="小时" value="hour"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="otherSetForm.duration_type==='hour'" label="时间换算"
                                          prop="time_conversion">
                                <el-input-number v-model="otherSetForm.time_conversion"
                                                 :controls="false"
                                                 :max="24"
                                                 :min="1"
                                                 :step="1"
                                                 step-strictly></el-input-number>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="other_site_footer">
                        <el-button size="small" @click="handleClickCancel">取消</el-button>
                        <el-button size="small" type="primary" @click="handleClickOtherConfirm">提交</el-button>
                    </div>
                </div>
            </div>
        </div>
        <userDepartmentPostSelection 
            v-if="userDepartmentPostVisible"
            :selectType="'departmentUserTag'"
            :userDepartmentPostSelected="userDepartmentPostSelected"
            :userDepartmentPostTitle="'人员范围'"
            :userDepartmentPostVisible.sync="userDepartmentPostVisible"
            @success="handleUserScopeSuccess"
        />
    </div>
</template>
<script>
import {
    GetDepartmentList,
    getFormFields,
    GetUserList,
    workOrderSet,
    workOrderSetDetail,
    workOrderRoleEdit,
    workOrderRoleList,
    approvalSetList,
    roleDetail,
    workOrderRoleDelCheck
} from "@/api";
import ReviewFormDialog from "@/components/pComponents/ReviewFormDialog";
import userDepartmentPostSelection from "@/components/pComponents/userDepartmentPostSelection";
import draggable from "vuedraggable";

export default {
    name: "WorkOrderManagement",
    data() {
        return {
            tabActiveName: 'process',
            process_anchor: 'initiate',
            processSetForm: {
                is_create_approve: 1,//创建需审批
                is_auto_assign: 0,//自动分配
                auto_assign_rule: [
                    {
                        rules: [{
                            type: "field",
                            operator: "=",
                            field_key: "",
                            field_name: "",
                            field_text: [],
                            field_type: "",
                            field_value: []
                        }],
                        boolean: "and",
                        assign_uids: []
                    },
                ],//自动分配规则
                mode: 1,//工单模式
                is_travel_approve: 0,//差旅需审批
                is_clock: 0,//需要打卡
                is_share: 0,//允许共享
                is_feedback: 0,//需要反馈
                is_force_remind: 0,//强制提醒
                is_transfer: 0,//允许转单
                is_finish_upload: 0,//完成需上传
                is_finish_content: 0,//完成需填写内容
                is_evaluate: 1,//需要评价
            },
            reviewFormTypeList: [
                {
                    title: "电脑端",
                    value: "pc",
                    form_title: "新增商机",
                    form_desc: "模拟真实新增工单页面效果，预览中填写的数据系统不会保存，有些控件如附件、图片、收付款账户、发票不支持在预览中操作",
                },
                {
                    title: "移动端",
                    value: "mobile",
                    form_title: "新增商机",
                    form_desc: "模拟真实新增工单页面效果，预览中填写的数据系统不会保存，有些控件如附件、图片、收付款账户、发票不支持在预览中操作",
                },
            ],
            ruleFieldList: {},
            loading: false,
            reviewFormDialog: false,
            formInfoList: [],
            departmentList: [],
            contactOptions: [],
            assignContactOptions: [], // 自动分配可选的人
            rolesSetForm: {
                create_user: {
                    role_type: 'create_user',
                    role_name: '工单创建者',
                    role_range: [],
                    role_range_text: []
                },
                assign_user: {
                    role_type: 'assign_user',
                    role_name: '工单分配人',
                    role_range: [],
                    role_range_text: []
                },
                processing_user: [
                    {
                        role_type: 'processing_user',
                        role_name: '实施工程师',
                        role_range: [],
                        role_range_text: []
                    }
                ],
                custom: []
            },
            rolesSetFormRules: {
                assign_user: [{
                    required: true,
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        if (!this.rolesSetForm.assign_user.role_name) return callback(new Error('请输入角色名称'))
                        callback()
                    }
                }],
                processing_user: [{
                    required: true,
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        if (!this.rolesSetForm.processing_user.some(item => !item.role_name)) return callback(new Error('请输入角色名称'))
                        callback()
                    }
                }]
            },
            otherSetForm: {
                duration_type: 'half_day',
                time_conversion: 8,
            },
            userDepartmentPostVisible: false,
            userDepartmentPostSelected: [],
            roleSelectType: '',
            processingIndex: 0,
            uids: []
        }
    },
    components: {ReviewFormDialog, draggable, userDepartmentPostSelection},
    async created() {
        this.loading = true
        this.getAssignContactList()
    },
    methods: {
        //获取自动分配联系人
        getAssignContactList(keyword) {
            if(!this.assignContactOptions.length) {
                roleDetail({
                    role_type: "processing_user"
                }).then(res=> {
                    if(res.code === 200) {
                        this.assignContactOptions = res.data || []
                    }
                    this.getSetFormData()
                })
            } else {
                this.getSetFormData()
            }
        },
        getSetFormData() {
            workOrderSetDetail().then(res => {
                if (res.code === 200) {
                    for (let processSetFormKey in this.processSetForm) {
                        this.processSetForm[processSetFormKey] = res.data[processSetFormKey]
                    }
                    this.uids = res.data.auto_assign_rule.map(rules => rules.assign_uids).flat()
                    if (this.contactOptions.length === 0) {
                        this.getContactList();
                    }
                    if(this.assignContactOptions.length) {
                        // 把不存在的分配人删除掉
                        this.processSetForm.auto_assign_rule.forEach(item=> {
                            if(item.assign_uids && item.assign_uids.length) {
                                const optionIds = this.assignContactOptions.map(option=> option.id)
                                const SetOptionIds = new Set(optionIds)
                                const hasIds = item.assign_uids.filter(id => SetOptionIds.has(id));
                                this.$set(item, 'assign_uids', hasIds)
                            }
                        })
                    }
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            })
            this._getFromFields()
        },
        //表单字段获取
        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: 'workorders'
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = res.data
                    this.ruleFieldList = {}
                    res.data.forEach(item => {
                        if (item.field_type === 'radio' || item.field_type === 'checkbox') {
                            item.condition_type = "options";
                            this.$set(this.ruleFieldList, item.field_key, item)
                        } else if (item.field_type === 'date' || item.field_type === "date_range") {
                            item.condition_type = "date";
                            this.$set(this.ruleFieldList, item.field_key, item)
                        } else if (item.field_type === 'radio_workorder_type') {
                            item.condition_type = "radio_workorder_type";
                            this.$set(this.ruleFieldList, item.field_key, item)
                        } else if (item.field_type === 'contact') {
                            item.condition_type = "contact";
                            this.$set(this.ruleFieldList, item.field_key, item)
                        } else if (item.field_type === 'department') {
                            item.condition_type = item.field_type;
                            this.$set(this.ruleFieldList, item.field_key, item)
                        } else if (item.field_type === 'workorder_role') {
                            item.condition_type = item.field_type;
                            this.$set(this.ruleFieldList, item.field_key, item)
                            this.handleWorkOrderRoleSelectFocus(this.ruleFieldList[item.field_key])

                        }
                    })
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },

        //点击头部标题
        handleClickHeaderTitleItem(tab) {
            this.tabActiveName = tab;
            if (tab === 'roles') {
                this.loading = true
                workOrderRoleList().then(res => {
                    if (res.code === 200) {
                        this.rolesSetForm.processing_user = [
                            {
                                role_type: 'processing_user',
                                role_name: '实施工程师',
                                role_range: [],
                                role_range_text: []
                            }
                        ]
                        this.rolesSetForm.custom = []
                        if (res.data.length) {
                            res.data.forEach(item => {
                                if (item.role_range.length) {
                                    item.role_range_text = item.role_range.flatMap(group => Object.values(group).flatMap(arr => arr.map(item => item.name)));
                                }
                                if (item.role_type === 'create_user') {
                                    if (item.role_range.length) {
                                        this.rolesSetForm.create_user.id = item.id
                                        this.rolesSetForm.create_user.company_id = item.company_id
                                        this.rolesSetForm.create_user.uid = item.uid
                                        this.rolesSetForm.create_user.role_range_text = item.role_range_text || []
                                        this.rolesSetForm.create_user.role_range = item.role_range || []
                                    }
                                } else if (item.role_type === 'assign_user') {
                                    if (item.role_range.length) {
                                        this.rolesSetForm.assign_user.id = item.id
                                        this.rolesSetForm.assign_user.company_id = item.company_id
                                        this.rolesSetForm.assign_user.uid = item.uid
                                        this.rolesSetForm.assign_user.role_range_text = item.role_range_text || []
                                        this.rolesSetForm.assign_user.role_range = item.role_range || []
                                    }
                                } else if (item.role_type === 'processing_user') {
                                    this.rolesSetForm.processing_user.push(item)
                                } else if (item.role_type === 'custom') {
                                    this.rolesSetForm.custom.push(item)
                                }
                            })
                            if (this.rolesSetForm.processing_user.length > 1) {
                                this.rolesSetForm.processing_user.shift()
                            }
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                    this.loading = false
                })
            } else {

            }
        },

        //点击右侧锚点
        handleClickProcessAnchorItem(anchor) {
            this.process_anchor = anchor;
            const targetElement = document.getElementById(anchor + '_title'); // 获取目标元素
            if (targetElement) {
                targetElement.scrollIntoView({behavior: 'smooth', block: 'start'}); // 平滑滚动到目标元素
            }
        },

        //点击工单自定义表单
        handleClickSetFormField() {
            this.$router.push({
                name: "workOrderFormSet",
            })
        },

        //预览表单
        handleClickReview() {
            this.reviewFormDialog = true
        },

        //点击前往审批后台设置
        handleClickApproveProcess(name, type) {
            approvalSetList({ keyword: name }).then((res) => {
                if (res.code === 200) {
                    const data = res.data;
                    if (data.length) {
                        // 能获取到审批配置的数据，就跳转到对应的审批流程设计页面
                        const approvals = data[0].approvals || [];
                        const itemData = approvals.find((item) => item.type == type);
                        if (itemData.id) {
                            this.$router.push({
                                name: 'approveAdminSettings',
                                query:{
                                    id:itemData.id,
                                    tab_name: "ApprovalProcess"
                                }
                            })
                        } else {
                            this.$router.push({
                                name: "approveAdminManagement",
                            });
                        }
                    } else {
                        // 获取不到就到审批设置页面
                        this.$router.push({
                            name: "approveAdminManagement",
                        });
                    }
                }
            });
        },

        //规则字段选择事件
        handleSelectFieldKeyChange(item) {
            const field = this.ruleFieldList[item.field_key];
            item.field_name = field.field_name
            item.field_type = field.field_type
            item.field_value = []
            item.field_text = []
            if (field.field_type === "department") {
                if (this.departmentList.length === 0) {
                    this.getDepartmentList();
                }
            } else if (field.field_type === "contact") {
                if (this.contactOptions.length === 0) {
                    this.getContactList();
                }
            }
        },

        //选择项字段选择事件
        handleOptionsFieldChange(rule, val) {
            const {options} = this.ruleFieldList[rule.field_key].extend
            rule.field_text = options.filter(item => val.includes(item.value)).map(item => item.label); // 提取 label
        },
        handleWorkOrderRoleSelectFocus(rule) {
            if (!rule.hasOwnProperty('options') || rule.options.length === 0 || !rule.options.every(user=> user.id)) {
                this.getRoleUserList(rule)
            }
        },
        //获取角色对应的用户
        getRoleUserList(field) {
            roleDetail({
                role_id: field.extend && field.extend.relate_role_id
            }).then(res => {
                if (res.code === 200) {
                    this.$set(field, 'options', res.data)
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        //选择工单类型
        handleWorkOrderFieldChange(rule, val) {
            const {options} = this.ruleFieldList[rule.field_key].extend
            rule.field_text = options.filter(item => val.includes(item.id)).map(item => item.name);
        },

        //联系人字段选择事件
        handleContactFieldChange(rule, user) {
            if (rule.field_value.includes(user.uid)) {
                rule.field_text.push({
                    uid: user.uid,
                    name: user.name,
                })
            } else {
                rule.field_text.splice(rule.field_text.findIndex(item => item.uid === user.uid), 1)
            }
        },

        //联系人字段选择框标签移除事件
        handleRemoveContactTag(tag, rule) {
            rule.field_text.splice(rule.field_text.findIndex(item => item.uid === tag), 1)
        },

        //选择部门事件
        handleDepartmentCheckChange(data, checked, indeterminate, rule) {
            if (checked) {
                rule.field_text.push(data.relate_name);
                rule.field_value.push(data.relate_id);
            } else {
                rule.field_text = rule.field_text.filter((item) => item !== data.relate_name);
                rule.field_value = rule.field_value.filter((item) => item !== data.relate_id);
            }
        },

        //清除部门选择
        handleClickClearDepartment(rule, index) {
            rule.field_value = [];
            rule.field_text = [];
            this.$refs[`dep_select_tree${index}`][0].setCheckedKeys([]);
        },

        //移除多选部门的标签
        handleRemoveDepartmentTag(rule, index) {
            rule.field_value.shift();
            const keys = rule.field_value.map((item) => item);
            rule.field_value = [];
            rule.field_text = [];
            this.$refs[`dep_select_tree${index}`][0].setCheckedKeys([]);
            this.$nextTick(() => {
                this.$refs[`dep_select_tree${index}`][0].setCheckedKeys(keys);
            });
        },

        //日期字段选择事件
        handleDateFieldChange(val, rule) {
            rule.field_text = val;
        },

        //获取联系人列表
        getContactList(keyword) {
            GetUserList({
                keyword,
                uids: this.uids
            }).then((res) => {
                if (res.code === 200) {
                    this.contactOptions = res.data || [];
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        //获取部门列表
        getDepartmentList() {
            GetDepartmentList().then((res) => {
                if (res.code === 200) {
                    this.departmentList = res.data || [];
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        //点击添加规则
        handleClickAddAssignRule() {
            this.processSetForm.auto_assign_rule.push({
                rules: [{
                    type: "field",
                    operator: "=",
                    field_key: "",
                    field_name: "",
                    field_text: [],
                    field_type: "",
                    field_value: []
                }],
                boolean: "and",
                assign_uids: []
            },)
        },

        //点击添加条件
        handleClickAddPrerequisites(rule) {
            rule.push({
                type: "field",
                operator: "=",
                field_key: "",
                field_name: "",
                field_text: [],
                field_type: "",
                field_value: []
            })
        },

        //自动分配切换事件
        handleIsAutoAssignChange(val) {
            if (val === 0) {
                this.processSetForm.auto_assign_rule = [{
                    rules: [{
                        type: "field",
                        operator: "=",
                        field_key: "",
                        field_name: "",
                        field_text: [],
                        field_type: "",
                        field_value: []
                    }],
                    boolean: "and",
                    assign_uids: []
                }]
            }
        },

        //点击切换工单实施模式
        handleClickWorkOrderMode(mode) {
            this.processSetForm.mode = mode
            if (mode === 1) {
                this.processSetForm.is_travel_approve = 0
            }
        },

        //点击取消事件
        handleClickCancel() {
            this.$router.back(-1)
        },

        //工单流程确定事件
        handleClickProcessConfirm() {
            const is_all_fill = this.processSetForm.auto_assign_rule.every(item=> item.rules.every(ruleItem=> ruleItem.field_key && ruleItem.field_value && ruleItem.field_value.length))
            if(!is_all_fill) return this.$message.error("请填写自动分配条件")
            workOrderSet({
                ...this.processSetForm
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('设置成功')
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        //添加自定义实施角色
        handleClickAddProcessingRoles() {
            this.rolesSetForm.processing_user.push({
                role_type: 'processing_user',
                role_name: '',
                role_range: [],
                role_range_text: [],
                is_edit: true
            })
        },

        //工单创建者选择框聚焦事件
        handleCreatorSelectFocus() {
            if (this.rolesSetForm.create_user.role_range.length) {
                this.userDepartmentPostSelected = Object.entries(this.rolesSetForm.create_user.role_range[0]).flatMap(([key, items]) => {
                    // 根据输入的键生成 relate_type_id
                    return items.map(item => ({
                        relate_type_id: key === 'department' ? `${item.id}_App\\Models\\Department` : key === 'user' ? `${item.id}_App\\Models\\User` : `${item.id}_App\\Models\\UserTagRelate`,
                        relate_id: item.id,
                        relate_name: item.name,
                        relate_type: key === 'department' ? 'App\\Models\\Department' : key === 'user' ? 'App\\Models\\User' : 'App\\Models\\UserTagRelate'
                    }))
                });
            }
            this.userDepartmentPostVisible = true
            this.roleSelectType = 'create'
        },

        //工单分配人选择框聚焦事件
        handleAssigneeSelectFocus() {
            if (this.rolesSetForm.assign_user.role_range.length) {
                this.userDepartmentPostSelected = Object.entries(this.rolesSetForm.assign_user.role_range[0]).flatMap(([key, items]) => {
                    // 根据输入的键生成 relate_type_id
                    return items.map(item => ({
                        relate_type_id: key === 'department' ? `${item.id}_App\\Models\\Department` : key === 'user' ? `${item.id}_App\\Models\\User` : `${item.id}_App\\Models\\UserTagRelate`,
                        relate_id: item.id,
                        relate_name: item.name,
                        relate_type: key === 'department' ? 'App\\Models\\Department' : key === 'user' ? 'App\\Models\\User' : 'App\\Models\\UserTagRelate'
                    }));
                });
            }
            this.userDepartmentPostVisible = true
            this.roleSelectType = 'assign'
        },

        //工单实施角色选择框聚焦事件
        handleImplementerRolesSelectFocus(scope, index) {
            if (scope.length) {
                this.userDepartmentPostSelected = Object.entries(scope[0]).flatMap(([key, items]) => {
                    // 根据输入的键生成 relate_type_id
                    return items.map(item => ({
                        relate_type_id: key === 'department' ? `${item.id}_App\\Models\\Department` : key === 'user' ? `${item.id}_App\\Models\\User` : `${item.id}_App\\Models\\UserTagRelate`,
                        relate_id: item.id,
                        relate_name: item.name,
                        relate_type: key === 'department' ? 'App\\Models\\Department' : key === 'user' ? 'App\\Models\\User' : 'App\\Models\\UserTagRelate'
                    }));
                });
            }
            this.userDepartmentPostVisible = true
            this.roleSelectType = 'processing'
            this.processingIndex = index
        },

        //工单自定义角色选择框聚焦事件
        handleCustomRolesSelectFocus(scope, index) {
            if (scope.length) {
                this.userDepartmentPostSelected = Object.entries(scope[0]).flatMap(([key, items]) => {
                    // 根据输入的键生成 relate_type_id
                    return items.map(item => ({
                        relate_type_id: key === 'department' ? `${item.id}_App\\Models\\Department` : key === 'user' ? `${item.id}_App\\Models\\User` : `${item.id}_App\\Models\\UserTagRelate`,
                        relate_id: item.id,
                        relate_name: item.name,
                        relate_type: key === 'department' ? 'App\\Models\\Department' : key === 'user' ? 'App\\Models\\User' : 'App\\Models\\UserTagRelate'
                    }));
                });
            }
            this.userDepartmentPostVisible = true
            this.roleSelectType = 'custom'
            this.processingIndex = index
        },

        //人员选择确定事件
        handleUserScopeSuccess(data) {
            const result = data.reduce((acc, item) => {
                // 根据 relate_type 生成新的键
                const typeKey = item.relate_type.split('\\').pop().toLowerCase(); // 获取类型并转换为小写
                const formattedItem = {
                    id: item.relate_id,
                    name: item.relate_name
                };
                // 将格式化后的项添加到相应的数组中
                if (!acc[typeKey]) {
                    acc[typeKey] = []; // 如果没有该类型，则初始化为空数组
                }
                acc[typeKey].push(formattedItem); // 添加到对应的数组
                return acc; // 返回累加器
            }, {});
            const role_range_text = data.map(item => item.relate_name)
            if (this.roleSelectType === 'create') {
                this.rolesSetForm.create_user.role_range = [{
                    department: result.department || [],
                    user: result.user || [],
                    user_tag: result.usertagrelate || []
                }]
                this.rolesSetForm.create_user.role_range_text = role_range_text
            } else if (this.roleSelectType === 'assign') {
                this.rolesSetForm.assign_user.role_range = [{
                    department: result.department || [],
                    user: result.user || [],
                    user_tag: result.usertagrelate || []
                }]
                this.rolesSetForm.assign_user.role_range_text = role_range_text
            } else if (this.roleSelectType === 'processing') {
                this.rolesSetForm.processing_user[this.processingIndex].role_range = [{
                    department: result.department || [],
                    user: result.user || [],
                    user_tag: result.usertagrelate || []
                }]
                this.rolesSetForm.processing_user[this.processingIndex].role_range_text = role_range_text
            } else if (this.roleSelectType === 'custom') {
                this.rolesSetForm.custom[this.processingIndex].role_range = [{
                    department: result.department || [],
                    user: result.user || [],
                    user_tag: result.usertagrelate || []
                }]
                this.rolesSetForm.custom[this.processingIndex].role_range_text = role_range_text
            }
        },

        //添加自定义角色
        handleClickAddCustomRoles() {
            this.rolesSetForm.custom.push({
                role_type: 'custom',
                role_name: '',
                role_range: [],
                role_range_text: [],
                is_edit: true
            })
        },

        //点击编辑角色名称
        handleClickRoleNameEdit(item) {
            if (item.hasOwnProperty('is_edit')) {
                item.is_edit = !item.is_edit
            } else {
                this.$set(item, 'is_edit', true)
            }
        },

        //角色名称输入框失焦
        handleRoleNameInputBlur(item) {
            if (!item.role_name) return this.$message.error('请输入角色名称')
            this.$set(item, 'is_edit', false)
        },

        // 实施人员删除校验
        handleProcessingUserDel(item, index) {
            if(item.id) {
                workOrderRoleDelCheck({role_id: item.id}).then(res=> {
                    if(res.code === 200) {
                        if(res.data.is_exist) {
                            this.$message.error("该角色已被关联，如需删除，请先前往工单流程-自定义表单内容中修改")
                        } else {
                            this.rolesSetForm.processing_user.splice(index, 1)
                        }
                    }
                })
            } else {
                this.rolesSetForm.processing_user.splice(index, 1)
            }
        },

        // 其它类型删除
        handleCustomDel(item, index) {
            if(item.id) {
                workOrderRoleDelCheck({role_id: item.id}).then(res=> {
                    if(res.code === 200) {
                        if(res.data.is_exist) {
                            this.$message.error("该角色已被关联，如需删除，请先前往工单流程-自定义表单内容中修改")
                        } else {
                            this.rolesSetForm.custom.splice(index, 1)
                        }
                    }
                })
            } else {
                this.rolesSetForm.custom.splice(index, 1)
            }
        },

        //工单角色确定事件
        handleClickRolesConfirm() {
            const role = [
                this.rolesSetForm.create_user,
                this.rolesSetForm.assign_user,
                ...(this.rolesSetForm.processing_user || []),
                ...(this.rolesSetForm.custom || [])
            ];
            if(!this.rolesSetForm.assign_user.role_name) return this.$message.error("请填写角色名称")
            if(!this.rolesSetForm.processing_user.every(item=> item.role_name)) return this.$message.error("请填写角色名称")
            if(!this.rolesSetForm.custom.every(item=> item.role_name)) return this.$message.error("请填写角色名称")
            workOrderRoleEdit({
                role
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success(res.message)
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        //其他设置确定事件
        handleClickOtherConfirm() {

        },
    },
}
</script>
<style lang="scss" scoped>
.admin_manage_wrapper {
    width: 100%;
    height: 100%;
    background-color: #F7F8FA;
}

.admin_manage_header {
    padding: 0 16px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #E8E8E8;

    .admin_manage_header_title {
        font-size: 16px;
        line-height: 24px;
        color: #666666;
        padding: 12px 16px;
        cursor: pointer;
        position: relative;

        &.active {
            color: #2990FF;
            font-weight: 700;

            &::after {
                width: 100%;
                height: 2px;
                background-color: #2990FF;
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }

}

.admin_manage_content {
    width: 100%;
    height: calc(100% - 49px);
    overflow-y: hidden;

    .process_site_wrap {
        width: 620px;
        height: 100%;
        padding: 3px 0;
        margin: 0 auto;
        position: relative;

        .process_site_form_wrap {
            width: 100%;
            height: calc(100% - 52px);
            overflow-y: auto;
            background-color: #FFFFFF;
            border-radius: 8px;
            padding: 24px 24px 0;

            .auto_assign_rule_list {
                margin-top: 10px;

                .auto_assign_rule_item {
                    padding: 4px;
                    border-radius: 8px;
                    background: #EDF0F4;
                    margin-bottom: 16px;

                    .conditions_wrap {
                        background-color: #FFFFFF;
                        padding: 12px;
                        margin-bottom: 4px;
                        border-radius: 8px;
                        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);

                        .assign_rules_list {
                            margin-top: 16px;

                            .assign_rules_item {
                                height: 32px;
                                display: flex;
                                align-items: center;
                                gap: 8px;
                                margin-bottom: 12px;

                                .field_select_wrap {
                                    flex: 1;
                                    height: 32px;

                                    .el-select {
                                        width: 100%;
                                    }
                                }

                                .operator_select_wrap {
                                    width: 54px;
                                    height: 32px;

                                    ::v-deep .el-input__suffix {
                                        display: none;
                                    }
                                }

                                .field_value_form_wrap {
                                    flex: 1;
                                    height: 32px;

                                    .el-select {
                                        width: 100%;
                                    }

                                    .el-date-editor--daterange.el-input__inner {
                                        width: 100%;
                                    }
                                    .el-date-editor--daterange {
                                        ::v-deep {
                                            .el-range-separator {
                                            width: 16px;
                                                line-height: 30px;
                                                padding: 0;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        .title {
                            font-size: 16px;
                            font-weight: 700;
                            color: #333333;
                            line-height: 24px;
                        }

                        .link-label {
                            line-height: 22px;
                        }
                    }

                    .personnel_wrap {
                        background-color: #FFFFFF;
                        padding: 12px 12px 1px;
                        border-radius: 8px;
                        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);

                        .el-form-item {
                            .el-select {
                                width: 100%;
                            }
                        }
                    }
                }
            }

            ::v-deep .disable_form_item {
                .el-form-item__label {
                    color: #BFBFBF;
                }
            }

            .mode_list {
                display: flex;
                gap: 16px;
                margin-bottom: 16px;

                .mode_item {
                    flex: 1;
                    padding: 16px 0;
                    border-radius: 6px;
                    border: 1px solid #D9D9D9;
                    text-align: center;
                    color: #666666;
                    cursor: pointer;
                    font-size: 16px;
                    line-height: 24px;

                    &.active {
                        border-color: #2990FF;
                        color: #2990FF;
                        background: rgba(41, 144, 255, 0.12);
                    }
                }
            }
        }

        .process_site_footer {
            text-align: center;
            box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.08);
            padding: 10px 0;
            background-color: #FFFFFF;
            border-radius: 0 0 8px 8px;
        }

        .process_anchor_list {
            position: absolute;
            right: -100px;
            top: 27px;

            .process_anchor_item {
                padding: 4px 8px;
                line-height: 22px;
                color: #666666;
                cursor: pointer;
                border-left: 2px solid #E8E8E8;

                &.active {
                    color: #2990FF;
                    font-weight: 700;
                    border-color: #2990FF;
                }

                &:hover {
                    color: #4BA2FF;
                }
            }
        }
    }

    .roles_site_wrap {
        width: 620px;
        height: 100%;
        padding: 3px 0;
        margin: 0 auto;

        .roles_site_form_wrap {
            width: 100%;
            height: calc(100% - 52px);
            overflow-y: auto;
            background-color: #FFFFFF;
            border-radius: 8px;
            padding: 24px 24px 0;

            .el-select {
                width: 100%;
            }

            ::v-deep .role_name_input {
                .el-input__inner {
                    border: none;
                    background: rgba(0, 0, 0, 0.04);
                }
            }

            ::v-deep .el-form-item.is-required .el-form-item__label::before {
                display: none;
            }
            .el-select {
                ::v-deep .el-select__tags {
                    .el-tag__close {
                        display: none;
                    }
                }
            }
        }

        .roles_site_footer {
            text-align: center;
            box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.08);
            padding: 10px 0;
            background-color: #FFFFFF;
            border-radius: 0 0 8px 8px;
        }
    }

    .other_site_wrap {
        width: 620px;
        height: 100%;
        padding: 3px 0;
        margin: 0 auto;

        .other_site_form_wrap {
            width: 100%;
            height: calc(100% - 52px);
            overflow-y: auto;
            background-color: #FFFFFF;
            border-radius: 8px;
            padding: 24px 24px 0;

            .el-select {
                width: 100%;
            }

            ::v-deep .el-input-number {
                width: 100%;

                .el-input__inner {
                    text-align: left;
                }
            }
        }

        .other_site_footer {
            text-align: center;
            box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.08);
            padding: 10px 0;
            background-color: #FFFFFF;
            border-radius: 0 0 8px 8px;
        }
    }

    .page_little_title {
        padding-bottom: 12px;
        height: auto;
        border-bottom: 1px dashed #E8E8E8;
        margin-bottom: 10px;
    }

    .hint_text {
        font-size: 12px;
        color: #999999;
        line-height: 18px;
        margin-top: 2px;
    }

    .role_range_item {
        ::v-deep .el-form-item__label {
            width: 100%;
        }
    }

    .add_rule_btn {
        padding: 5px 0;
        text-align: center;
        border-radius: 4px;
        border: 1px dashed #2990FF;
        line-height: 22px;
        color: #2990FF;
        cursor: pointer;
    }
}
</style>